/**
 * API Utility
 * Axios instance with JWT Authorization header interceptor
 */

import axios from 'axios';
import { getToken, clearToken } from './auth';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

/**
 * Axios instance with Authorization header interceptor
 */
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request interceptor: Add Authorization header if token exists
 */
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor: Handle 401 Unauthorized (expired/invalid token)
 */
api.interceptors.response.use(
  (response) => response, // Pass through success responses
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid — clear token and redirect to login
      console.warn('[API] 401 Unauthorized — clearing token and redirecting to login');
      clearToken();
      
      // Redirect to login (unless already there)
      if (window.location.pathname !== '/login') {
        window.location.href = '/login?expired=true';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE };
